import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
	
	window.scrollTo(0, 0);

    return {
        type: 'INCUBACAO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('incubacaoForm', registro)
    ];
}

export function setAguardando(aguardando) {
    return {
        type: 'INCUBACAO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/incubacao`, {
				...registro,
				data_inicial: DateFormat.getDataAtual(),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('trilha'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/incubacao`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('trilha'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function getLista() {
	const request = axios.get(`${consts.API_URL}/incubacao`);
	return {
		type: 'INCUBACAO_LISTADO',
		payload: request
	};
}

export function getListaUsuario() {
	const request = axios.get(`${consts.API_URL}/usuario/listarSelect`);
	return {
		type: 'INCUBACAO_USUARIO_SELECT_LISTADO',
		payload: request
	};
}